import { render, staticRenderFns } from "./HerbPositions.vue?vue&type=template&id=94a9ff6a&scoped=true"
import script from "./HerbPositions.vue?vue&type=script&lang=js"
export * from "./HerbPositions.vue?vue&type=script&lang=js"
import style0 from "./HerbPositions.vue?vue&type=style&index=0&id=94a9ff6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a9ff6a",
  null
  
)

export default component.exports